import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Content from "../Modulos/Treinamentos/obrigatorios/Content";

const TreinamentosObrigatorios = () => {
    return (
        <>
            <NavBar
                title="TREINAMENTOS OBRIGATÓRIOS"
                prevDest="modulo/ssma/treinamentos"
            />
            <GenericBody>
                <Content />
            </GenericBody>
        </>
    );
};

export default TreinamentosObrigatorios;
